import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMail, FiMessageCircle, FiShield, FiCheck, FiFileText } = FiIcons;

const Footer = ({ openLeadCapture }) => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <motion.div
            className="flex flex-wrap justify-center items-center gap-8 text-sm"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex items-center space-x-2 text-green-400"><SafeIcon icon={FiShield} /><span>Secure Payments</span></div>
            <div className="flex items-center space-x-2 text-green-400"><SafeIcon icon={FiCheck} /><span>7-day Refund</span></div>
            <div className="flex items-center space-x-2 text-green-400"><SafeIcon icon={FiCheck} /><span>Trusted by 1000+ Coaches</span></div>
            <div className="flex items-center space-x-2 text-green-400"><SafeIcon icon={FiCheck} /><span>GDPR Safe</span></div>
          </motion.div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
            <div className="logo-banner mb-6">
              <span className="font-serif font-bold text-xl text-white">My Webinar</span>
            </div>
            <p className="text-gray-400 mb-6">
              Premium webinar platform for coaches, trainers, and business owners. AI-enhanced, automated, and designed for serious growth.
            </p>
            <div className="bg-blue-900/30 border border-blue-700 rounded-lg p-4">
              <p className="text-light-blue font-semibold text-sm">🔥 FY End Offer: Up to 90% OFF</p>
              <p className="text-xs text-gray-400 mt-1">Limited time offer ends soon</p>
            </div>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.1 }}>
            <h3 className="font-semibold text-lg mb-6">Quick Links</h3>
            <div className="space-y-3">
              <a href="https://mywebinar.in" target="_blank" rel="noopener noreferrer" className="block text-gray-400 hover:text-white transition-colors">Home</a>
              <a href="#features" className="block text-gray-400 hover:text-white transition-colors">Features</a>
              <a href="#pricing" className="block text-gray-400 hover:text-white transition-colors">Pricing</a>
              <a href="#testimonials" className="block text-gray-400 hover:text-white transition-colors">Success Stories</a>
            </div>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.2 }}>
            <h3 className="font-semibold text-lg mb-6">Support</h3>
            <div className="space-y-4">
              <a href="mailto:support@yinguru.com" className="flex items-center space-x-3 text-gray-400 hover:text-white transition-colors">
                <SafeIcon icon={FiMail} /><span>support@yinguru.com</span>
              </a>
              <a href="https://wa.me/919940890569?text=Hi,%20I%20need%20help%20with%20My%20Webinar%20Financial%20Year%20End%20offer" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 text-gray-400 hover:text-white transition-colors">
                <SafeIcon icon={FiMessageCircle} /><span>WhatsApp Support</span>
              </a>
            </div>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.3 }}>
            <h3 className="font-semibold text-lg mb-6">Get Started</h3>
            <div className="space-y-4">
              <motion.button
                onClick={openLeadCapture}
                className="w-full bg-gold hover:bg-gold/90 text-white px-6 py-3 rounded-lg font-bold transition-all hover-glow-gold flex items-center justify-center space-x-2"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <SafeIcon icon={FiFileText} /><span>Get More Results</span>
              </motion.button>
              <div className="bg-gold/10 border border-gold/30 rounded-lg p-4">
                <h4 className="font-semibold text-gold mb-2">7-Day Money-Back</h4>
                <p className="text-sm text-gray-300">Not satisfied? Get a full refund within 7 days. No questions asked.</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <motion.div
            className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="text-sm text-gray-400">© 2025 My Webinar. All rights reserved.</div>
            <div className="text-xs text-gray-500 text-center md:text-right max-w-md">
              This site is not part of the Facebook website or Facebook Inc. Additionally, this site is NOT endorsed by Facebook. FACEBOOK is a trademark of FACEBOOK, Inc.
            </div>
          </motion.div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;